// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__fzWgw","vLegacy":"SelectSecondary_vLegacy__362-T","error":"SelectSecondary_error__2u_iD","disabled":"SelectSecondary_disabled__3v_jh"};